import { SubAccountType } from "../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";

export const sptSteppersMap = {
    paymentsIn: "Payments in",
    adviserCharges: "Adviser charges",
    investment: "Investment selection",
    review: "Review",
    doc: "Documents / declaration",
    comfirm: "Confirmation",
};

export const productMap = {
    [SubAccountType.Sipp]: "SIPP",
    [SubAccountType.Npr]: "Pension",
    [SubAccountType.StocksIsa]: "ISA Stocks & Shares",
    [SubAccountType.PersonalPortfolio]: "Personal Portfolio",
    [SubAccountType.InvestmentAccount]: "Personal Portfolio",
    [SubAccountType.WrapCash]: "Cash Account",
};

export const FinancialAdviceMap = {
    true: "Yes",
    false: "No",
};
